module.exports = __webpack_public_path__ + "img/menu_btn.8b3ba70b.png";